import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import "./Header.css"

const Header = () => {
  const [hasScrolled, setHasScrolled] = React.useState(false)

  const handleScroll = event => {
    const scrollTop = window.pageYOffset

    if (scrollTop > 50) {
      setHasScrolled(true)
    } else {
      setHasScrolled(false)
    }
  }

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll")
    }
  }, [])

  return (
    <header className={hasScrolled ? "Header HeaderScrolled" : "Header"}>
      <div className="HeaderGroup">
        <Link to="/"> Inicio</Link>
        <Link to="/#patrocinadores">Patrocinadores </Link>
        <a href="/#sobreNosotros">Sobre nosotros</a>
        <Link to="/#technology">Tecnología</Link>
        <Link to="/#aliados">Aliados</Link>
        <a
          target="__blank"
          href="https://documenter.getpostman.com/view/6212290/TVKJwuAW"
        >
          <button>API</button>{" "}
        </a>
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
